import styled from 'styled-components';

const Day = styled.div`
  text-transform: capitalize;
`;

export default Day;
